import React from "react";
import style from "css/template.module.css";
import { Link } from "react-router-dom";

function MobileSmartSpace() {
  return (
    <>
      <section className={style.smart_space_list_section}>
        <Link
          className={style.smart_space_title}
          to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work`}
        >
          <p>스마트 워크 스페이스</p>
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
            alt=""
          />
        </Link>
        <ul className={style.smart_space_list}>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/reception`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/reception.png`}
                  alt=""
                />
              </div>
              <p>가상 리셉셔니스트</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/hotdesk`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/hotdesk.png`}
                  alt=""
                />
              </div>
              <p>자율좌석제</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/conference`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/conference.png`}
                  alt=""
                />
              </div>
              <p>회의실 예약 시스템</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/videoconference.png`}
                  alt=""
                />
              </div>
              <p>화상회의 시스템</p>
            </Link>
          </li>
        </ul>
        <Link
          className={style.smart_space_title}
          to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room`}
        >
          <p>스마트 강의실/교실</p>
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
            alt=""
          />
        </Link>
        <ul className={style.smart_space_list}>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/classRoom`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/classRoom.png`}
                  alt=""
                />
              </div>
              <p>하이브리드 스마트 강의실</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/group`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/group.png`}
                  alt=""
                />
              </div>
              <p>하이브리드 그룹 강의실</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/lab`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/lab.png`}
                  alt=""
                />
              </div>
              <p>하이브리드 스마트 실습실</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/laboratory`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/laboratory.png`}
                  alt=""
                />
              </div>
              <p>하이브리드 연구실/교수실</p>
            </Link>
          </li>
        </ul>
        <Link
          className={style.smart_space_title}
          to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth`}
        >
          <p>스마트 텔레헬스 시스템</p>
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
            alt=""
          />
          {/* <div className={style.disabled_menu_bg}>
                        <p className={style.disabled_menu_title}>스마트 텔레헬스 시스템</p>
                        <article className={style.disabled_menu_article}>
                            <p>곧 공개 예정</p>
                            <p>새로운 페이지가 곧 찾아옵니다.</p>
                        </article>
                    </div> */}
        </Link>
        <ul className={style.smart_space_list}>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/telehealth`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/telehealth.png`}
                  alt=""
                />
              </div>
              <p>원격 진료</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/telecollaboration`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/telecollaboration.png`}
                  alt=""
                />
              </div>
              <p>원격 회진</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/symposium`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/symposium.png`}
                  alt=""
                />
              </div>
              <p>원격 협진</p>
            </Link>
          </li>
          <li>
            <Link
              className={style.smart_space_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/symposium`}
            >
              <div className={style.smart_space_icon}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/symposium.png`}
                  alt=""
                />
              </div>
              <p>의료세미나/학술대회</p>
            </Link>
          </li>
        </ul>
      </section>
      <section className={style.smart_space_composition}>
        <p className={style.composition_title}>규모별 공간구성</p>
        <ul className={style.composition_menu_list}>
          <li>
            <Link
              className={style.composition_menu_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/individual`}
              state={{ status: "individual" }}
            >
              <p>1인 / 개인 사무실</p>
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                alt=""
              />
            </Link>
          </li>
          <li>
            <Link
              className={style.composition_menu_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/small`}
              state={{ status: "individual" }}
            >
              <p>중소형 회의실</p>
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                alt=""
              />
            </Link>
          </li>
          <li>
            <Link
              className={style.composition_menu_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/large`}
              state={{ status: "individual" }}
            >
              <p>대형 회의실</p>
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                alt=""
              />
            </Link>
          </li>
          <li>
            <Link
              className={style.composition_menu_item}
              to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/lounge`}
              state={{ status: "individual" }}
            >
              <p>공용라운지 및 오피스</p>
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                alt=""
              />
            </Link>
          </li>
        </ul>
      </section>
    </>
  );
}

export default MobileSmartSpace;
